import { render, staticRenderFns } from "./SdeptSerPrice.vue?vue&type=template&id=00bcbf6a&"
import script from "./SdeptSerPrice.vue?vue&type=script&lang=ts&"
export * from "./SdeptSerPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports